import React, { useState, useEffect, useRef } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaList, FaPen, FaPlus, FaSearch } from 'react-icons/fa';
import { ImCancelCircle } from 'react-icons/im';
import ReactSelect from '../../components/ReactSelect';
import api from '../../services/api';
import Alert from '../../components/Alert';
import { Link } from 'react-router-dom';
import { FaThumbsUp } from 'react-icons/fa';
import '../../css/financeiro-parcela-pagar.css';

export default function PainelPessoa() {
    const token = localStorage.getItem('token');
    const perfil = localStorage.getItem("perfil");
    const [filtro, setFiltro] = useState({});
    const [buscando, setBuscando] = useState(false);
    const [pessoas, setPessoas] = useState([]);
    const [selectedIds, setSelectedIds] = useState(new Set());
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const controllerRef = useRef(null);

    const toggleSelect = id => setSelectedIds(prev => {
        const n = new Set(prev);
        n.has(id) ? n.delete(id) : n.add(id);
        return n;
    });

    const total = pessoas.length;
    const totalPaginas = Math.max(1, Math.ceil(total / pageSize));
    const paginados = pessoas.slice((page - 1) * pageSize, page * pageSize);
    const selectedArr = [...selectedIds];

    const toggleAll = () =>
        paginados.length > 0 && selectedIds.size === paginados.length
            ? setSelectedIds(new Set())
            : setSelectedIds(new Set(paginados.map(r => r.id)));

    const buscar = () => {
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        setBuscando(true);
        api({
            method: 'get',
            action: '/participante',
            token: token,
            params: {
                ...filtro,
                ...{ tipoCadastro: "pessoa" },
                // relações que esta tela lê (o endpoint só carrega o que for declarado)
                include: 'enderecomunicipio,evento,cargo',
                ...{
                    orderBy: {
                        situacaoRegistro: "asc"
                    }
                }
            },
            signal: controllerRef.current.signal
        })
            .then(response => {
                setPessoas(response.data.data);
                setPage(1);
                setBuscando(false);
            }).catch(err => {
                if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
                setBuscando(false);
                //console.log(err)
            });
    };

    const excluir = (id) => {
        Alert({
            icon: "error",
            confirmButton: "Sair",
            denyButton: <><FaThumbsUp size={20} /> Excluir</>,
            title: "Excluir",
            callBack: (result) => {
                if (result.isDenied) {
                    api({
                        method: 'delete',
                        action: '/participantes',
                        token: token,
                        data: {
                            idParticipantes: id
                        }
                    })
                        .then(function (response) {
                            buscar();
                        })
                        .catch(function (error) {
                            //console.log(error)
                        });
                }
            }
        });
    };

    useEffect(() => { //onload
        document.querySelector("#nome")?.focus(); //autofocus no nome
        buscar();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Pessoas</h1></div>
                    <div className="fin-pp__actions">
                        <Link to="/rhCargo" className="fin-pp__btn fin-pp__btn--pill">
                            <FaList size={14} /> Cargos
                        </Link>
                        <Link to="/cadastroPessoa" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill">
                            <FaPlus size={14} /> Nova Pessoa
                        </Link>
                    </div>
                </div>

                <form className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }} onSubmit={e => { buscar(); e.preventDefault(); }}>
                    <div className="fin-pp__filters">
                        <div className="fin-pp__field">
                            <label className="fin-pp__label">Nome</label>
                            <input
                                id="nome"
                                className="fin-pp__input"
                                style={{ paddingLeft: 14 }}
                                type="text"
                                placeholder="Buscar pelo nome da pessoa"
                                onChange={e => setFiltro({ ...filtro, "nome": e.target.value })}
                            />
                        </div>
                        <div className="fin-pp__field">
                            <label className="fin-pp__label">Usuário</label>
                            <input
                                id="email"
                                className="fin-pp__input"
                                style={{ paddingLeft: 14 }}
                                type="text"
                                placeholder="Buscar pelo usuário"
                                onChange={e => setFiltro({ ...filtro, "email": e.target.value })}
                            />
                        </div>
                        <div className="fin-pp__field">
                            <label className="fin-pp__label">Cargo</label>
                            <ReactSelect
                                placeholder="Todos"
                                value={filtro.cargo ? { value: filtro.cargo, label: filtro.nomeCargo } : null}
                                onChange={(e) => setFiltro({
                                    ...filtro,
                                    "cargo": e ? e.value : null,
                                    "nomeCargo": e ? e.label : null
                                })}
                                isClearable={true}
                                loadOptions={(input) => {
                                    return api({
                                        method: 'get',
                                        action: '/rhCargo',
                                        token: token,
                                        params: { nome: input }
                                    })
                                        .then(response => {
                                            let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome }));
                                            return options;
                                        })
                                        .catch(function (error) {
                                            //console.log(error);
                                        });
                                }}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={buscando}>
                            <FaSearch size={14} style={{ marginRight: 6 }} />{buscando ? 'Buscando...' : 'Buscar'}
                        </button>
                    </div>
                </form>

                {selectedArr.length === 1 && (['admin', 'diretor', 'rh'].includes(perfil)) && (
                    <div style={{ marginBottom: 8, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                        <button type="button" className="fin-pp__btn fin-pp__btn--danger fin-pp__btn--sm" onClick={() => excluir(selectedArr[0])}>
                            <ImCancelCircle size={14} /> Excluir
                        </button>
                    </div>
                )}

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: 40 }}>
                                        <input type="checkbox" checked={paginados.length > 0 && selectedIds.size === paginados.length} onChange={toggleAll} />
                                    </th>
                                    <th style={{ width: 60 }}></th>
                                    <th>Situação</th>
                                    <th>Código</th>
                                    <th>Nome</th>
                                    <th>Cargo</th>
                                    <th>Usuário</th>
                                    <th>Eventos Responsável</th>
                                </tr>
                            </thead>
                            <tbody>
                                {buscando
                                    ? <tr><td colSpan={8} className="fin-pp__empty"><span className="fin-pp__loading"><span className="fin-pp__spin"></span>Buscando...</span></td></tr>
                                    : paginados.length === 0
                                        ? <tr><td colSpan={8} className="fin-pp__empty">Nenhum registro</td></tr>
                                        : paginados.map(row => (
                                            <tr key={row.id}>
                                                <td>
                                                    <input type="checkbox" checked={selectedIds.has(row.id)} onChange={() => toggleSelect(row.id)} />
                                                </td>
                                                <td>
                                                    <Link to={"/cadastroPessoa/" + row.id} className="fin-pp__rowbtn"><FaPen size={14} /></Link>
                                                </td>
                                                <td>
                                                    <span className={`fin-pp__pill ${row.situacaoRegistro === 'ativo' ? 'is-ok' : 'is-muted'}`}>{row.situacaoRegistro}</span>
                                                </td>
                                                <td style={{ textAlign: 'right' }}>{row.codigo ?? ""}</td>
                                                <td>{row.evento ? row.nome + ' - ' + row.evento.codigo + ' - ' + row.evento.nome : row.nome}</td>
                                                <td>{row.cargo ? row.cargo.nome : ""}</td>
                                                <td>{row.email ?? ""}</td>
                                                <td style={{ textAlign: 'center' }}>
                                                    {(() => {
                                                        const quantidade = row.quantidadeEventos ?? 0;
                                                        if (quantidade > 0) {
                                                            return (
                                                                <Link
                                                                    to={`/evento?responsavelagencia=${row.id}`}
                                                                    className="fin-pp__btn fin-pp__btn--sm"
                                                                    style={{ textDecoration: 'none' }}
                                                                >
                                                                    {quantidade} evento{quantidade !== 1 ? 's' : ''}
                                                                </Link>
                                                            );
                                                        }
                                                        return <span style={{ color: 'var(--fin-muted, #999)' }}>0 eventos</span>;
                                                    })()}
                                                </td>
                                            </tr>
                                        ))
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="fin-pp__pagination">
                        <div className="fin-pp__pagination-info">{total} registros</div>
                        <div className="fin-pp__pagination-ctrls">
                            <select className="fin-pp__select" style={{ height: 34 }} value={pageSize} onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }}>
                                <option value={15}>15 / pág</option>
                                <option value={30}>30 / pág</option>
                                <option value={50}>50 / pág</option>
                            </select>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Anterior</button>
                            <span className="fin-pp__pagination-info">{page} / {totalPaginas}</span>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page >= totalPaginas} onClick={() => setPage(p => p + 1)}>Próxima</button>
                        </div>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
